import React from "react";
import { useTranslation } from "react-i18next";

function ArturCommitment() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="arturCommitment arturCommitment-box">
        <h3>{t("admin.cert.ah1")}</h3>
        <ul className="content">
          <li>
            <span>01</span> {t("admin.cert.ap1")}
          </li>
          <li>
            <span>02</span> {t("admin.cert.ap2")}
          </li>
          <li>
            <span>03</span> {t("admin.cert.ap3")}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default ArturCommitment;
